'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _taggedTemplateLiteral2 = require('babel-runtime/helpers/taggedTemplateLiteral');
var _taggedTemplateLiteral3 = _interopRequireDefault(_taggedTemplateLiteral2);
var _templateObject = (0, _taggedTemplateLiteral3.default)(['\n  width: ', ';\n  height: ', ';\n  padding: 0px;\n  cursor: ', ';\n'], ['\n  width: ', ';\n  height: ', ';\n  padding: 0px;\n  cursor: ', ';\n']);
var _react = require('react');
var _react2 = _interopRequireDefault(_react);
var _propTypes = require('prop-types');
var _propTypes2 = _interopRequireDefault(_propTypes);
var _styledComponents = require('styled-components');
var _styledComponents2 = _interopRequireDefault(_styledComponents);
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
var SVG = function SVG(props) {
  return _react2.default.createElement('svg', props);
};
var SvgElement = (0, _styledComponents2.default)(SVG)(_templateObject, function (props) {
  return props.width;
}, function (props) {
  return props.height;
}, function (props) {
  return props.onClick ? 'pointer' : 'initial';
});
var Svg = function Svg(props) {
  var onClick = props.onClick,
    className = props.className,
    config = props.config;
  var viewBox = config.viewBox,
    width = config.width,
    height = config.height,
    paths = config.paths,
    polylines = config.polylines,
    fill = config.fill,
    stroke = config.stroke,
    strokeWidth = config.strokeWidth,
    strokeLinecap = config.strokeLinecap,
    strokeLinejoin = config.strokeLinejoin;
  var pathElements = paths ? paths.map(function (_ref) {
    var path = _ref.path,
      color = _ref.color,
      transform = _ref.transform;
    return _react2.default.createElement('path', {
      fill: color,
      d: path,
      transform: transform
    });
  }) : null;

  /* eslint-disable */
  var polylineElements = polylines ? polylines.map(function (points, i) {
    return _react2.default.createElement('polyline', {
      key: i,
      points: points
    });
  }) : null;
  /* eslint-enable */

  return _react2.default.createElement(SvgElement, {
    onClick: onClick,
    className: className,
    width: width,
    height: height,
    viewBox: viewBox,
    fill: fill,
    stroke: stroke,
    strokeWidth: strokeWidth,
    strokeLinecap: strokeLinecap,
    strokeLinejoin: strokeLinejoin
  }, pathElements, polylineElements);
};
Svg.propTypes = {
  className: _propTypes2.default.string,
  onClick: _propTypes2.default.func,
  config: _propTypes2.default.object // eslint-disable-line
};
exports.default = Svg;